import { Injectable } from "@angular/core";
import { Session, Token } from "./auth.service";
import { Device } from "./device.service";
import { SecureDataStatusResponse, SecureDataType } from "./securedata.sevice";
import { BehaviorSubject } from "rxjs";

export interface StateChangedModel {
    Type: SecureDataType;
    Data: unknown;
    RawData: string;
    Id: number;
}

@Injectable({
    providedIn: 'root'
})
export class StateService {

    private _onSecureDataCurrentUpdate: BehaviorSubject<StateChangedModel | null> = new BehaviorSubject<StateChangedModel | null>(null);

    private _token: Token | undefined;
    private _session: Session | undefined;

    private _device: Device | undefined;

    public get Device(): Device | undefined {
        return this._device;
    }

    public set Device(value: Device) {
        this._device = value;
    }
    private _connectionid: string | undefined;

    public get ConnectionId(): string | undefined {
        return this._connectionid;
    }

    public set ConnectionId(value: string) {
        this._connectionid = value;
    }

    private _methodType: string | undefined;

    public get MethodType(): string | undefined {
        return this._methodType;
    }

    public set MethodType(value: string) {
        this._methodType = value;
    }


    public get Token(): Token | undefined {
        return this._token;
    }

    public get Session(): Session | undefined {
        return this._session;
    }

    public set Session(value: Session) {
        this._session = value;
    }

    public set Token(value: Token) {
        this._token = value;
    }

    private _currentStatus: SecureDataStatusResponse | undefined;

    public get CurrentStatus(): SecureDataStatusResponse | undefined {
        return this._currentStatus;
    }

    public set CurrentStatus(value: SecureDataStatusResponse) {
        if (value) {
            const stateModel = (value as unknown) as StateChangedModel;
            try {
                if (value.RawData && value.RawData.length > 0) {
                    stateModel.Data = JSON.parse(value.RawData);
                } else {
                    stateModel.Data = undefined;
                }
                this.NotifySecureDataCurrent(stateModel);
            } catch (error) {
                console.error(error);
            }
        }
        this._currentStatus = value;
    }

    public get Provider(): string {
        if(!this._currentStatus || !this._currentStatus.RawData) {
            return "";
        }
        const x = JSON.parse(this._currentStatus?.RawData)
        if (x && x.internetProvider) {
            return x.internetProvider;
        }

        return ""
    }

    public get OnSecureDataCurrentUpdate() {
        return this._onSecureDataCurrentUpdate.asObservable();
    }

    NotifySecureDataCurrent(val: StateChangedModel) {
        this._onSecureDataCurrentUpdate.next(val);
    }


}